import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { publishedPolicyLinks, routes } from "../config/routes";
import { siteConfig } from "../config/site";
import { headerCategories } from "../data/catalogue";
import { SearchForm } from "./SearchForm";

const information = [
  { label: "About", to: routes.about },
  { label: "Delivery & Returns", to: routes.delivery },
  { label: "FAQ", to: routes.faq }
];

function Wordmark() {
  return (
    <>
      <span className="wordmark-mark" aria-hidden="true">
        BO
      </span>
      <span className="wordmark-name">
        Beautify <i>Ourselves</i>
      </span>
    </>
  );
}

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();
  const liveCategories = headerCategories();

  useEffect(() => {
    setMenuOpen(false);
    setSearchOpen(false);
  }, [location.pathname, location.search]);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <div className="preview-bar">{siteConfig.prelaunchNotice}</div>
      <header className="site-header">
        <div className="header-primary">
          <Link className="wordmark header-wordmark" to="/" aria-label={`${siteConfig.brandName} home`}>
            <Wordmark />
          </Link>
          <div className="header-search-desktop">
            <SearchForm id="header-search" compact />
          </div>
          <div className="header-tools">
            <button
              className="search-toggle"
              type="button"
              aria-expanded={searchOpen}
              aria-controls="header-search-panel"
              onClick={() => {
                setSearchOpen((value) => !value);
                setMenuOpen(false);
              }}
            >
              Search
            </button>
            <button
              className="nav-toggle"
              type="button"
              aria-expanded={menuOpen}
              aria-controls="site-nav"
              onClick={() => {
                setMenuOpen((value) => !value);
                setSearchOpen(false);
              }}
            >
              <span className="sr-only">{menuOpen ? "Close menu" : "Open menu"}</span>
              <span />
              <span />
            </button>
          </div>
        </div>
        <div
          id="header-search-panel"
          className={`header-search-panel${searchOpen ? " is-open" : ""}`}
        >
          <SearchForm id="header-search-mobile" compact />
        </div>
        <nav
          id="site-nav"
          className={`site-nav${menuOpen ? " is-open" : ""}`}
          aria-label="Primary navigation"
        >
          <NavLink to={routes.shop} end>
            Shop
          </NavLink>
          {liveCategories.map((category) => (
            <NavLink key={category.id} to={`${routes.shop}/${category.id}`}>
              {category.name}
            </NavLink>
          ))}
          {information.map((item) => (
            <NavLink key={item.to} to={item.to}>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
    </>
  );
}

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div>
          <Link className="wordmark wordmark-light" to="/">
            <Wordmark />
          </Link>
          <p>Beauty, chosen with care and explained clearly.</p>
        </div>
        <div>
          <h2>Visit</h2>
          <Link to={routes.shop}>Shop</Link>
          <Link to={routes.search}>Search</Link>
          <Link to={routes.about}>About us</Link>
        </div>
        <div>
          <h2>Help</h2>
          {publishedPolicyLinks.map((item) => (
            <Link key={item.to} to={item.to}>
              {item.label}
            </Link>
          ))}
          <Link to={routes.faq}>Frequently asked questions</Link>
        </div>
        <div>
          <h2>Shopping</h2>
          <p>
            Preview prices are shown in GBP and may change before ordering opens.
            <br />
            Delivery is charged separately. Ireland ordering is not available.
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
        <span>No orders or payments are being accepted.</span>
      </div>
    </footer>
  );
}

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search]);
  return null;
}

export function Layout() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <Header />
      <Outlet key={location.pathname} />
      <Footer />
    </>
  );
}
